const StockMessage = () => import("~/views/StockMessage/ListView.vue");

export {
  StockMessage
};
